import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessPolicyService } from '../services/access-policy.service';

function redirectToDashboard(): ReturnType<Router['createUrlTree']> {
  return inject(Router).createUrlTree(['/dashboard']);
}

function redirectToBankAccounts(): ReturnType<Router['createUrlTree']> {
  return inject(Router).createUrlTree(['/bank-accounts']);
}

export const bankReadGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  return accessPolicy.canReadBankAccounts() ? true : redirectToDashboard();
};

export const bankManageGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  return accessPolicy.canManageBankAccounts() ? true : redirectToBankAccounts();
};

export const bankStatementImportGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  return accessPolicy.canImportBankStatements() ? true : redirectToBankAccounts();
};

export const bankReconcileGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  return accessPolicy.canReconcile() ? true : redirectToBankAccounts();
};

export const bankReconcilePeriodGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  return accessPolicy.canManageReconcilePeriod() ? true : redirectToBankAccounts();
};

export const bankReconciliationReportGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  return accessPolicy.canReadBankAccounts() && accessPolicy.canReadReports()
    ? true
    : redirectToBankAccounts();
};
